import * as React from 'react';
import Box from '@mui/material/Box';
import { options } from '@config';
import Loading from '../../../../auxiliares/loading';
import Notifications from './notificationContent'
import { TypographyBrand } from '../../../../getLPTheme';

export default function NotificationsContainer () {

    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true); 
    const userId = localStorage.getItem("CLUB-VIP-USER")

    const handleListNotifications = async () => {
        const response = await fetch((options.api.url + "user"), {
            method: 'GET',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json'
            },
            // body: JSON.stringify({ uid }),
        })
        const data = await response.json();
        const usersTable = data.usersSearched
        const items = usersTable.find((row) => row.user === userId);
        // const items = searchedRowData.notifications
        return items
    }

    React.useEffect(()=> {
        const db = handleListNotifications().then((e) => {
            setItems(e);
            setLoading(false);
        });
    },[loading]);

    return (
        <Box>
            <TypographyBrand sx={{pb:2, fontSize: {xs: '6vw', md: '2vw'}}}>
                Mis Notificaciones
            </TypographyBrand>
            {loading ? <Loading/>: <Notifications items={items}/>}
        </Box>
    )
}